// One path for every export (SPEC F4, F5): make the file, hand it to the share sheet or a download, and
// say what was made in one toast. The export code itself loads only now, on the tap (CLAUDE.md lazy rule).
import { useAppStore } from '../../app/store';

export interface Made { fileName: string; bytes: Uint8Array; type: string; what: string }

export async function shareExport(made: Made): Promise<void> {
  const { deliver, download, makeFile } = await import('../../export/deliver');
  const showToast = useAppStore.getState().showToast;
  const file = makeFile(made.bytes, made.fileName, made.type);
  const result = await deliver(file);
  if (result === 'cancelled') return;
  if (result === 'needs-tap') {
    // The render outlived the tap, so the browser wants a fresh one before it opens the share sheet.
    showToast({
      message: `Made ${made.what}`,
      // A fresh tap; if the share sheet still refuses, the file downloads instead, so the tap always does something.
      action: { label: 'Share', run: () => void deliver(file).then((r) => { if (r === 'needs-tap') download(file); }) },
    });
    return;
  }
  showToast({ message: `Made ${made.what}` });
}
